import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Media } from '@klickdata/core/media/src/media.model';
import { MobileService, SideNaveActionsTypes, SideNaveDataTypes } from '@klickdata/core/mobile';
import { AppScope } from '@klickdata/core/resource';
import { DialogDisplayImgComponent } from 'apps/klickdata/src/app/shared/dialog/dialog-display-img/dialog-display-img.component';
import { MatTableBase } from 'apps/klickdata/src/app/shared/table/mat-table-base';
import { filter, map, switchMap, takeUntil } from 'rxjs';
import { K3MediaListingService } from '../k3-media-listing.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageDeletedComponent, MessageService } from '@klickdata/core/message';

@Component({
    selector: 'app-media-listing-general',
    templateUrl: './media-listing-general.component.html',
    styleUrls: ['./media-listing-general.component.scss'],
    providers: [K3MediaListingService],
})
export class MediaListingGeneralComponent extends MatTableBase<Media> implements AfterViewInit {
    @Output() onMediaClick: EventEmitter<Media> = new EventEmitter<Media>();
    @Input() public columns = ['id', 'thumbnil', 'filename', 'description', 'tags', 'created_at', 'tools'];
    @Input() public hasExpansionFilter = true;
    AppScope = AppScope;

    constructor(
        protected listService: K3MediaListingService,
        protected mobileService: MobileService,
        protected cdr: ChangeDetectorRef,
        protected dialog: MatDialog,
        protected route: ActivatedRoute,
        protected router: Router,
        protected message: MessageService
    ) {
        super(cdr, mobileService, listService);
    }
    ngAfterViewInit(): void {
        super.ngAfterViewInit();
        this.route.queryParams.pipe(filter((params) => params.action === 'addImage')).subscribe(() =>
            setTimeout(() => {
                this.addMedia();
                this.router.navigate([this.router.url.split('?')[0]]);
            }, 500)
        );
    }

    public addMedia() {
        this.mobileService.updateSideNavSub({
            dataType: SideNaveDataTypes.ADD_IMAGE_TO_LIST,
            data: {
                type: 'addImage',
            },
        });

        this.mobileService
            .getSideNavAction()
            .pipe(
                filter((action) => action === SideNaveActionsTypes.POSITIVE),
                switchMap(() => this.mobileService.getSideNavResponseData()),
                filter((data) => data.type === 'addImage'),
                takeUntil(this.destroy),
                map((data) => data.value)
            )
            .subscribe((media) => {
                this.dataSource.replace(new Media(media));
                this.cdr.markForCheck();
            });
    }
    public delete(id: number) {
        this.mobileService.updateSideNavSub({
            dataType: SideNaveDataTypes.GENERAL_NOTIFIER,
            data: {
                icon: 'delete',
                title: $localize`Delete Image`,
                contentBody: $localize`You are about to delete this image. Please use caution and make sure that you really intend to delete before confirming delete below.`,
                positiveBtn: $localize`Delete`,
                negativeBtn: $localize`Cancel`,
            },
        });
        this.mobileService
            .getSideNavAction()
            .pipe(
                filter((action) => action === SideNaveActionsTypes.POSITIVE),
                switchMap((res) => {
                    if (res) {
                        return this.listService.destroy(id);
                    }
                })
            )
            .subscribe((action) => {
                if (action) {
                    this.message.openMessage(MessageDeletedComponent);
                    this.dataSource.refresh();
                }
            });
    }
    public view(media: Media) {
        this.dialog.open(DialogDisplayImgComponent, {
            maxWidth: '60%',
            data: media.id,
        });
    }
}
